import LayoutHeader from "../Components/LayoutScaffold/LayoutHeader";
import Navigation from "../../Components/Navigation";
import * as React from "react";

export const HeaderLayout = (props: any) => {
    return (
        <div className='header-layout'>
            <LayoutHeader showMenuModifier={false} showLogo={true} showTopUp={false} />
            {props.children}
        </div>
    )
}

export const SidebarLayout = (props: any) => {
    return (
        <div className='dynamic-sidebar-layout'>
            <Navigation showMenuModifier={true} showLogo={true} isBranded={true} />
            {props.children}
        </div>
    )
}

export const ContentOnlyLayout = (props: any) => {
    return (
        <div className={'minimal-layout'}>
            {props.children}
        </div>
    )
}

export const HeaderSidebarLayout = (props: any) => {
    return (
        <div className='header-dynamic-sidebar-layout'>
            <LayoutHeader showMenuModifier={true} showLogo={true} isBranded={true} />
            <Navigation />
            {props.children}
        </div>
    )
}

export const SidebarHeaderLayout = (props: any) => {
    return (
        <div className='dynamic-sidebar-layout'>
            <Navigation showLogo={true} isBranded={true} />
            <div className='header-content-layout'>
                <LayoutHeader showMenuModifier={true} />
                {props.children}
            </div>
        </div>
    )
}